module.exports = __webpack_public_path__ + "img/check_circle_green.5b62f068.svg";